module.exports = __webpack_public_path__ + "static/img/staffPosition.85969485.svg";